export const toMoney = (cost?: string): string | undefined => {
  if (cost == null || isNaN(+cost)) return
  if (cost == 0) return 'Free' // eslint-disable-line eqeqeq

  let costString = `$${parseFloat(cost).toFixed(2)}`
  if (costString.indexOf('.00') !== -1) costString = costString.substring(0, costString.length - 3)
  return costString
}
